






























































































































import Vue from 'vue'
import { Component } from 'vue-property-decorator';

export enum CookieOption {
    Necessary = "Necessary",
    GoogleAnalytics = "Google Analytics",
}

@Component({
    name: 'CookieBox'
})
export default class CookieBox extends Vue {
    public enabledOptions: string[] = [ CookieOption.Necessary ];
    public visible = false;
    public optionsView = false;

    get googleAnalyticsEnabled(): boolean {
        return this.optionEnabled(CookieOption.GoogleAnalytics);
    }
    set googleAnalyticsEnabled(value: boolean) {
        if (value) {
            this.enableOption(CookieOption.GoogleAnalytics);
        } else {
            this.disableOption(CookieOption.GoogleAnalytics);
        }
    }

    private optionEnabled(value: string): boolean {
        return this.enabledOptions.includes(value);
    }

    private enableOption(value: string) {
        if (!this.optionEnabled(value)) {
            this.enabledOptions.push(value);
        }
    }

    private disableOption(value: string) {
        const index = this.enabledOptions.indexOf(value);
        if (index > -1) {
            this.enabledOptions.splice(index, 1);
        }
    }

    mounted(): void {
        const googleAnalyticsEnabled = Vue.$cookies.get('googleAnalyticsEnabled');

        if (typeof googleAnalyticsEnabled === 'boolean') {
            this.googleAnalyticsEnabled = googleAnalyticsEnabled;
        } else if (typeof googleAnalyticsEnabled === 'string') {
            this.googleAnalyticsEnabled = Boolean(JSON.parse(googleAnalyticsEnabled));
        } else {
            this.visible = true;
        }

        this.updateGoogleAnalyticsLibrary(this.googleAnalyticsEnabled);
    }

    acceptAll(): void {
        this.googleAnalyticsEnabled = true;
        this.saveAndClose();
    }

    saveAndClose(): void {
        this.save();
        this.close();
    }

    save(): void {
        Vue.$cookies.set('googleAnalyticsEnabled', this.googleAnalyticsEnabled, 60 * 60 * 24 * 365);
    }

    close(): void {
        this.updateGoogleAnalyticsLibrary(this.googleAnalyticsEnabled);
        this.visible = false;
    }

    private updateGoogleAnalyticsLibrary(value: boolean) {
        if (value) {
            this.$gtag.optIn();

            this.$gtag.pageview({
                /* eslint-disable @typescript-eslint/camelcase */
                page_path: this.$router.currentRoute.path,
            });
        } else {
            this.$gtag.optOut();
        }
    }
}
